import { returnValueForProp } from "./adjustable-type-value";
import type {
  CarSetup,
  PartInstanceMeasurementCoordinates,
  PartInstanceMeasurementRotation,
} from "./generated/graphql";
import type { DeepPartial } from "./utils";

type AdjustablePropertyReturnType =
  | string
  | number
  | boolean
  | PartInstanceMeasurementCoordinates
  | PartInstanceMeasurementRotation
  | null
  | undefined;

export const getAdjustablePropertyValueFromPartInstance = (
  specString: string,
  carSetup: DeepPartial<CarSetup> | null | undefined,
): AdjustablePropertyReturnType => {
  const specSplit = specString.replace(")", "").split(".");
  const specID = specSplit[1];
  const location = specSplit[specSplit.length - 1];
  const indexString = specSplit[specSplit.length - 2];
  if (!indexString) {
    return `Part instance not found, ${specString} ${specSplit.join(".")}`;
  }
  const index = parseFloat(indexString);
  const partInstance = carSetup?.chassisAssembly?.nestedPartInstances?.find(
    item => item?.specificationID === specID && item?.readingLocation === location,
  );
  if (!partInstance) {
    return `Part instance not found, spec: ${specID} location: ${location}`;
  }
  const measurement = partInstance.measurements?.find(item => item?.idx === index);
  if (!measurement) {
    return `Measurement not found, spec: ${specID} location: ${location} measurement: ${index}`;
  }
  const specification = carSetup?.chassisSpec?.customSpecs?.find(spec => spec?._id === specID);

  const propType =
    specification &&
    "adjustableProperties" in specification &&
    specification.adjustableProperties?.find(item => item?.index === index);
  if (!propType || !("__typename" in propType)) return undefined;

  return returnValueForProp(propType.__typename as string, measurement);
};
